import type { AccommodationDayView } from 'components/AccommodationKit/AccommodationCalendar/AccommodationCalendar.types'
import { fillArray } from 'lib/array/arrayUtils'
import { addMonths, beginningOfToday, formatIsoDate } from 'lib/datetime/dateUtils'

export interface FeaturedDateRange {
  // Type of featured day
  type: 'special' | 'loyalty'
  // Booking satisfies this date range if check-in is on or after this date, in ISO 8601
  startIsoDate: string
  // Booking satisfies this date range if check-out is on or before this date, in ISO 8601
  endIsoDate: string
}

export function generateStaticDayViews(
  timezone?: string,
  featuredDateRanges?: Utils.NonEmptyArray<FeaturedDateRange> | undefined,
): Array<AccommodationDayView> {
  const calendarStartDate = beginningOfToday(timezone)
  return fillArray(36).flatMap((monthIndex) => {
    const month = addMonths(calendarStartDate, monthIndex)
    const daysInMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate()
    const daysLeftInMonth = monthIndex === 0 ? daysInMonth - month.getDate() + 1 : daysInMonth

    return fillArray(
      daysLeftInMonth,
      dayIndex => monthIndex === 0 ? dayIndex + month.getDate() : dayIndex + 1,
    ).map((day): AccommodationDayView => {
      const date = new Date(month.getFullYear(), month.getMonth(), day)
      const isoDate = formatIsoDate(date)
      const featured = featuredDateRanges?.find(({ startIsoDate, endIsoDate }) => startIsoDate <= isoDate && isoDate <= endIsoDate)?.type
      return {
        date: isoDate,
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate(),
        soldOut: false,
        priceType: 'default',
        durationUnit: 'night',
        featured,
      }
    })
  })
}
